// Module
var code = "<div class=\"flex layout-column\">\n    <mn-system-parameter class=\"flex\" key=\"oximetry_config\" attr=\"chart_colors\">\n        <mn-oximetry-config-table mn-model=\"vm.model\" mn-auto-save=\"vm.handleAutoSave\" attr=\"chart_colors\">\n        </mn-oximetry-config-table>\n    </mn-system-parameter>\n</div>";
// Exports
module.exports = code;